import type { TFunction } from 'i18next';
import { number } from 'yup';

import yup from '../../../shared/validation';

export function getProgramValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
    description: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256')),
    exercise: yup.object().required(t('formikValidation.exerciseRequired')),
    programSetItems: yup.array().of(
      // validate it in submit(type, value, value2, sets)
      yup.object().shape({
        sets: number()
          .min(1, t('formikValidation.setsMinValue'))
          .required(t('formikValidation.setsCountRequired')),
        programSetItemOptions: yup.array().of(
          yup.object().shape({
            value: yup
              .number()
              .nullable()
              .min(0, t('formikValidation.minValue').replace('{0}', '0')),
            value2: yup
              .number()
              .nullable()
              .min(0, t('formikValidation.minValue').replace('{0}', '0')),
          }),
        ),
      }),
    ),
  });
}
